module.exports = __webpack_public_path__ + "img/logo-white.bff0ada6.png";